import {CSSProperties, FC} from 'react';


export interface IIconDocumentProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconDocument: FC<IIconDocumentProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M9.667 4.002V4h8.554c.429 0 .779.364.779.794v14.412a.784.784 0 0 1-.772.794H5.772a.767.767 0 0 1-.548-.238.812.812 0 0 1-.224-.568V8.8l4.667-4.798ZM7.2 8.8h2.466V6.264L7.2 8.8Zm4.021-3.2v4a.79.79 0 0 1-.777.8h-3.89v8h10.89V5.6h-6.223Z" clipRule="evenodd" />
        </svg>
    );
};
